import { Injectable } from '@angular/core';
import { BaseApi } from './_base-api';
import { map, Observable } from 'rxjs';
import { CreateRailRequest, EditRailRequest, GetRailsResult, RailDTO } from '@models';
import { ItemRecord } from '@controladad/ng-base';


@Injectable({ providedIn: 'root' })
export class RailsApiService extends BaseApi<RailDTO> {
  constructor() {
    super('/AdminPanel/Rails');
  }

  getRails(): Observable<GetRailsResult> {
    return http$.get<GetRailsResult>('/AdminPanel/GetRails');
  }

  getRailItems(): Observable<ItemRecord<number>[]> {
    return this.getRails().pipe(
      map((result) => result.rails
        .filter((rail) => rail.isActive)
        .map((rail) => ({ 
          label: rail.name.english || rail.name.arabic || 'Unnamed Rail', 
          value: rail.id! 
        }))
      )
    );
  }

  addRail(request: CreateRailRequest): Observable<any> {
    return http$.post('/AdminPanel/AddRail', request);
  }

  editRail(request: EditRailRequest): Observable<any> {
    return http$.put('/AdminPanel/EditRail', request);
  }

  deleteRail(railId: number): Observable<any> {
    return http$.delete('/AdminPanel/DeleteRail', {
      body: { railId }
    });
  }

  getRailDetails(railId: number): Observable<{ rail: RailDTO }> {
    return http$.get<{ rail: RailDTO }>('/AdminPanel/GetRailDetails', {
      params: { RailId: railId.toString() }
    });
  }
}
